// Copyright (c) 2020 WiseTime. All rights reserved.

import { createAction } from "@reduxjs/toolkit"
import { Init } from "../../app/rpc"
import { CreateUserCueRequestSchema } from "../../generated/wisetime/user/cues/v4/user_cues_pb"

export const createUserCue = createAction<Init<typeof CreateUserCueRequestSchema>>("user-cues/create-user-cue")
export const createUserCueFailed = createAction("user-cues/create-user-cue-failed")
